import React, { useState, useEffect, useContext, useRef } from "react";
import PersistentDataGrid from "../../components/PersistentDataGrid";
import { useParams, useNavigate } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";
import update from "immutability-helper";
import FormControlLabel from "@mui/material/FormControlLabel";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { REFRESH_TOKEN_MUTATION, STAFF_MODULE_ACCESS_QUERY } from "../../graphQL/user_qry";
import { GET_ALL_APPLICANTS_BY_TERM_ID_QUERY } from "../../graphQL/term_applicant_qry";
import {
  GET_TERM_DATA_BY_TERM_UUID,
  UPDATE_NO_OF_SEATS_MUTATION,
} from "../../graphQL/term_qry";
import { useQuery, useManualQuery, useMutation, ClientContext } from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  Checkbox,
  Tooltip,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormHelperText,
  makeStyles,
  Link,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import styled from "styled-components";

import Header from "./Header.js";

import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

import { GET_USER_DATA_BY_USERNAME } from "../../graphQL/register_qry";
import { GET_STAFF_CLIENTS_BY_STAFF_Uuid_QUERY } from "../../graphQL/user_qry";
import { GET_STAFF_CLIENT_GROUPS, GET_STAFF_GROUPS } from "../../graphQL/group_qry";
import { TENANT_CLIENT_LIST_QUERY } from "../../graphQL/client_qry";
import { CLIENT_GROUP_LIST_QUERY } from "../../graphQL/group_qry";
import { DELETE_GROUP_USER_MUTATION } from "../../graphQL/group_user";

import trashImg from "../../assets/icons/trash.png";
import FolderIcon from "@mui/icons-material/Folder";
import folderImg from "../../assets/icons/folder_bread_crump.png";
import PlaylistAddCheckCircleOutlinedIcon from "@mui/icons-material/PlaylistAddCheckCircleOutlined";

import UpdateGroupsDialog from "./UpdateGroupsDialog";
import AlertDialog from "../../components/AlertDialog.js";
import { project_url } from "../../constants/Data";

var findAnd = require("find-and");

const StyledTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -45px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
  }
`;
const StyledTooltip2 = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -45px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    margin-top: 4px;
  }
`;
const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    //textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14, //16,
    fontFamily: "Arial",
  },
  buttonStyle: {
    borderRadius: 4,
    // width: "250px",
    // padding: 0,
    color: "#fff",
    // height: "40px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "&.MuiDataGrid-root": {
      //  minWidth: 980,
      //  width:"100%"
      //  overflowX: 'scroll'
    },

    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 12,
    },
  },
  dataGridFooterStyle: {
    height: 80,
    marginBottom: 0,
    backgroundColor: "#99D4FF",
    display: "flex",
    alignItems: "center",
  },
  dataGridFooterTextStyle: {
    color: "#0D47A1",
    fontSize: 18,
    fontWeight: 700,
    // marginLeft: 10,
  },
  textFieldStyle: {
    // height: 55,
    // marginBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      height: 45,
      borderRadius: 10,
      fontSize: 16,
    },
  },
  noOfSeatsBoxStyle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    alignItems: "center",
    borderRadius: "8px",
  },
  noOfSeatsTextStyle: {
    width: 60,
    cursor: "pointer",
    fontWeight: 500,
    borderRadius: "8px",
    height: 30,
    fontSize: 16,
    display: "flex",
    padding: 5,
    paddingRight: 10,
    paddingLeft: 10,
    alignItems: "center",
    lineHeight: 1,
    "&:hover": {
      backgroundColor: "#E2F2FF",
    },
  },
  iconStyle: {
    marginLeft: 12,
    height: 18,
    padding: 10,
    display: "flex",
    alignItems: "center",
    border: "1px solid lightGray",
    borderRadius: "4px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#EEEEEE",
    },
  },
  selectStyle: {
    // marginTop: 10,
    borderRadius: "15px",
    minWidth: 250,
    height: 35,
    // marginBottom: 10,
    "& .MuiOutlinedInput-input": {
      textAlign: "left",
    },
  },
  linkStyle: {
    // display: "flex",
    // flexDirection: "row",
    // alignItems: "center",
    marginTop: ".5rem",
    marginBottom: ".5rem",
  },
}));

function StaffGroups() {
  const navigate = useNavigate();
  const client = useContext(ClientContext);
  const classes = useStyles();
  const [pathname] = useState(window.location.pathname);

  const { staffUuid } = useParams();
  const  combinedGroupLink = `${project_url}/staff/` + staffUuid + '/groups/combined-group-permissions';
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [loadContent, setLoadContent] = useState(false);
  const [staffClients, setStaffClients] = useState([]);
  const [staffClientName, setStaffClientName] = useState("");
  const [staffClientId, setStaffClientId] = useState(-1);
  //const [currClientUuid, setCurrClientUuid] = useState("");
  const [rows, setRows] = useState([]);
  const [staffGroupList , setStaffGroupList] = useState([]);
  const [staffGroupsCount , setStaffGroupsCount] = useState(0)
  const [clntAllGrpAndIfIsStfGrp2, setClntAllGrpAndIfIsStfGrp2] = useState(null);
  const [openUpdateGroupsDialog, setOpenUpdateGroupsDialog] = useState(null);
  const [alertDeleteMsg, setAlertDeleteMsg] = useState([]);
  const [permissionAccess, setPermissionAccess] = useState(true);

  const [getUserDataByUserName] = useManualQuery(GET_USER_DATA_BY_USERNAME);
  const [getStaffClients] = useManualQuery(GET_STAFF_CLIENTS_BY_STAFF_Uuid_QUERY);
  const [getTenantAllClients] = useManualQuery(TENANT_CLIENT_LIST_QUERY);
  const [getStaffClientGroups] = useManualQuery(GET_STAFF_CLIENT_GROUPS);
  const [getStaffGroups] = useManualQuery(GET_STAFF_GROUPS);
  const [getClientAllGroups] = useManualQuery(CLIENT_GROUP_LIST_QUERY);
  const [deleteStaffGroupMutation] = useMutation(DELETE_GROUP_USER_MUTATION);

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  
  const tenantName = localStorage.getItem("tenantName");
  const tenantId = localStorage.getItem("tenantId");

  let tenantUserId = 0;
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let clientId = 0;
  if (localStorage.getItem("clientId")) clientId = localStorage.getItem("clientId");

  let clientName = "";
  if (localStorage.getItem("clientName")) clientName = localStorage.getItem("clientName");

  let isTenantAdmin = false;  
  if(localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);

  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  const checkAccess = async () => {
    //check if staff has access to module
    
    const {
            loading: accessDataLoading,
            error: accessDataError,
            data: accessData,
          } = await checkStaffModuleAccess({
            variables: {
              tenantUserId: parseInt(tenantUserId),  
              clientId: parseInt(clientId), 
              moduleName: "Staff",
              modulepageName: "List",     
            },
          });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {  
        
      let additionalActions = accessData.staffModuleAccess.additionalActions.split("|");
      
      if(additionalActions.find(a => a == "Groups")){
        setPermissionAccess(true);}
      else { setPermissionAccess(false);}      
    }

    if (  accessDataError &&
          accessDataError.graphQLErrors &&
          accessDataError.graphQLErrors[0].message === "Signature has expired"
       ) {
            navigate(`${project_url}/signin`);
          }
  }

    useEffect(() => {
    window.scrollTo(0, 0);
    (() => getUserData())();
  }, [staffUuid]);

   useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);




  const getUserData = async () => {
    // Get user information
    const {
      loading: userDataLoading,
      error: userDataError,
      data: userData,
    } = await getUserDataByUserName({
      variables: { username: staffUuid },
    });

    if (userData && !userData.getUserDataByUsername) {
      navigate(`${project_url}/tenant/dashboard`);
    } else if (
      userData &&
      userData.getUserDataByUsername &&
      userData.getUserDataByUsername == null
    ) {
      navigate(`${project_url}/tenant/dashboard`);
    } else if (!userDataLoading && userData && userData.getUserDataByUsername) {
      setLoadContent(true);
      setFirstName(userData.getUserDataByUsername.firstName);
      setLastName(userData.getUserDataByUsername.lastName);
    }
    if (
      userDataError &&
      userDataError.graphQLErrors &&
      userDataError.graphQLErrors[0].message === "Signature has expired"
    ) {
      navigate(`${project_url}/signin`);
    }

    

    // Get list of all client names for the tenant
    const {
      loading: loadingClient,
      error: errorClient,
      data: dataClient,
    } = await getTenantAllClients();
    if (dataClient && dataClient.tenantClientList) {
      setStaffClients(dataClient.tenantClientList);

            
      if (localStorage.getItem("clientId"))
         setStaffClientId(localStorage.getItem("clientId")); 
      else
        setStaffClientId(dataClient.tenantClientList[0].clientId);        
      

      if  (localStorage.getItem("clientName"))
        setStaffClientName(localStorage.getItem("clientName"));
      else
        setStaffClientName(dataClient.tenantClientList[0].name);      
       
      
    }
  };

  useEffect(() => {
    (() => getStaffClientGroupsFunc())();
  }, [staffClientId]);

  const getStaffClientGroupsFunc = async () => {
    
    if (staffClientId === -1) return;
    const {
      loading: dataLoading,
      error: usataError,
      data,
    } = await getStaffClientGroups({
      variables: { username: staffUuid, clientId: parseInt(staffClientId) },
    });
    if (!dataLoading && data && data.getStaffClientGroups) {
      setRows(
        data.getStaffClientGroups.map(group => ({
          id: group.groupId,
          groupUuid: group.groupUuid,
          name: group.name,
          description: group.desc,
        }))
      );
      setStaffGroupList(data.getStaffClientGroups)
      setStaffGroupsCount(data.getStaffClientGroups.length)
      //getStaffGroupsFunc(); 

    }

  };

  const getStaffGroupsFunc = async () => {
    
    const {
      loading: dataLoading,
      error: usataError,
      data,
    } = await getStaffGroups({
      variables: { username: staffUuid },
    });
    if (!dataLoading && data && data.getStaffGroups) {
      setStaffGroupsCount(data.getStaffGroups.length) 

    }

  };


  useEffect(() => {
    (() => getClientAllGroupsFunc())();
  }, [rows]);

  const getClientAllGroupsFunc = async () => {
    if (!rows) return;
    
    // Get all groups for the selected client
    const {
      loading: clntLoading,
      error: clntError,
      data: clntData,
    } = await getClientAllGroups({
      variables: { clientId: parseInt(staffClientId) },
    });
    if (!clntLoading && clntData && clntData.getAllClientGroups) {
      setClntAllGrpAndIfIsStfGrp2(
        clntData.getAllClientGroups.map(group => ({
          groupId: group.groupId,
          name: group.name,
          isStfGrp: Object.values(rows).some(item => item.id === group.groupId)
            ? true
            : false
        }))
      );
      
    }
  };

  const columns = [
    {
      field: "name",
      headerName: "Group Name",
      headerClassName: "super-app-theme--header",
      minWidth: 130,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "description",
      headerName: "Description",
      headerClassName: "super-app-theme--header",
      minWidth: 130,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "action",
      headerName: "Action",
      headerClassName: "super-app-theme--header",
      minWidth: 200,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        return (
          <Box
            pt={1}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <StyledTooltip title="View group permissions">
              <Box
                style={{
                  paddingRight: 15,
                  cursor: "pointer",
                  height: 24,
                  weight: 24,
                }}
              >
                <PlaylistAddCheckCircleOutlinedIcon 
                  color="action"
                  onClick={() => navigate(`${project_url}/staff/${staffUuid}/groups/${rows.row.groupUuid}/group-permissions`)}
                />
              </Box>
            </StyledTooltip>

            {staffGroupsCount === 1 ?              (
                
                <StyledTooltip title="Staff should assign to one group at least.">
                <img
                  style={{
                    paddingRight: 15,
                    paddingTop: 6,
                    height: 24,
                    weight: 24,
                    cursor: "auto",
                    filter: "grayscale(1)",
                    opacity: 0.5,
                  }}
                  src={trashImg}
                  />
                </StyledTooltip>
                
              )
              :
              (
                
                <StyledTooltip title="Remove this staff from group">
                <img
                  style={{
                    paddingRight: 15,
                    paddingTop: 6,
                    height: 24,
                    weight: 24,
                    cursor: "pointer",
                  }}
                  src={trashImg}
                  onClick={() => deleteStaffGrpFunc(rows.row)}
                />
              </StyledTooltip>
              
              )
            }
            
          </Box>
        );
      },
    },
  ];

  const handleClientChange = event => {
    let select = findAnd.returnFound(staffClients, {
      name: event.target.value,
    });    
    if (select === undefined) return;
    setStaffClientName(select.name);
    setStaffClientId(select.clientId);
    //setCurrClientUuid(select.clientUuid);
    //localStorage.setItem("selectedClientUuid", select.clientUuid);
    //localStorage.setItem("clientName", select.name);
    //localStorage.setItem("clientId", select.clientId);
  };

  const handleUpdateGroups = () => {
    setOpenUpdateGroupsDialog({
      staffFullName: firstName + " " + lastName,
      clientName: clientName,
      username: staffUuid,
      staffGroupsCount: staffGroupsCount,
      clntAllGrpAndIfIsStfGrp2,
    });
  };

  const reloadPageFunc = flag => {
    if (flag) {
      getStaffClientGroupsFunc();
    }
  };

  const deleteStaffGrpFunc = row => {
    let msg =
      "Are you sure you want to remove staff " +
      '"' +
      firstName +
      " " +
      lastName +
      '"' +
      " from group " +
      '"' +
      row.name +
      '"' +
      " in client " +
      '"' +
      clientName +
      '"' +
      "?";

    setAlertDeleteMsg({
      title: "Remove Staff from Group",
      type: "deleteConfirmation",
      msg,
      groupId: row.id,
    });
  };

  const deleteGroupUserFunc = async groupId => {
    const {
      loading: loadingGroupDelete,
      error: errorGroupDelete,
      data: dataGroupDelete,
    } = await deleteStaffGroupMutation({
      variables: {
        groupId: parseInt(groupId),
        username: staffUuid,
      },
    });
    if (!loadingGroupDelete && dataGroupDelete && dataGroupDelete.deleteGroupUser) {
      getStaffClientGroupsFunc();
    }
    if (errorGroupDelete) {
      console.log("Error", errorGroupDelete, dataGroupDelete);
    }
  };

  function DataGridTitle() {
    return (
      <>
        <Grid
          container
          xs={12}
          style={{
            paddingTop: 10,
            paddingBottom: 10,
            width: "100%",
            display: "flex",
            justifyContent: "right",
            alignItems: "right",
          }}
        >
          <Grid
            item
            xs={2}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingRight: 20,
            }}
          >
            <StyledTooltip2 title="Update staff groups">
              <Button
                variant="contained"
                // color="primary"
                className={classes.buttonStyle}
                size="small"
                onClick={handleUpdateGroups}
              >
                Manage Groups
              </Button>
            </StyledTooltip2>
          </Grid>
        </Grid>
        <Divider />
      </>
    );
  }
  
  if (loadContent)
  if (permissionAccess)
    return (
      <div className={classes.root}>
        <Header
          breadcrumbs={[
            { label: firstName + " " + lastName, link: null },
            { label: "Staff Groups", link: null },
          ]}
        />
        <div className={classes.container}>
          <Box mt={2} mb={2} textAlign="center">
            <Typography variant="h1" style={{ fontSize: 20 }}>
              Staff: {firstName} {lastName} Groups
            </Typography>
          </Box>
          <Divider />
          <Box
            pt={2}
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Typography style={{ paddingRight: 5 }} variant="h2">
              Clients:
            </Typography>
            <Box pl={1}>
              <Select
                className={classes.selectStyle}
                value={staffClientName}
                margin="normal"
                onChange={handleClientChange}
              >
                {staffClients.map(client => (
                  <MenuItem value={client.name}>{client.name}</MenuItem>
                ))}
              </Select>
            </Box>
          </Box>
          <Box
            pt={1}
            pb={1}
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            {staffGroupList.length > 0 ? 
              (
              <>
                 <Link className={classes.linkStyle} to={combinedGroupLink}  component={RouterLink}>
                  <StyledTooltip title="View staff combined group permissions">
                    <Typography variant="h2" className={classes.text}>
                      Combined Group Permissions
                    </Typography>
                  </StyledTooltip>
                </Link>
              </>
              )
             :
             (
              <>
              
              <StyledTooltip title="View staff combined group permissions" className={classes.linkStyle}>
                <Typography variant="h2" className={classes.text}>
                  Combined Group Permissions
                </Typography>
              </StyledTooltip>
              
              </>
             )
           }
            
          </Box>
          <PersistentDataGrid
            persistenceKey="staff-groups"
            className={classes.dataGridStyle}
            columns={columns}
            rows={rows}
            showCellRightBorder={true}
            slots={{
              toolbar: DataGridTitle,
            }}
            getRowId={row => row.id}
            autoHeight={true}
            experimentalFeatures={{ newEditingApi: true }}
            pageSizeOptions={[10, 25, 50]}
            localeText={{
              noRowsLabel:
                "This staff is not assigned to any group in the selected client.",
            }}
          />
          {openUpdateGroupsDialog && (
            <UpdateGroupsDialog
              staffFullName={openUpdateGroupsDialog.staffFullName}
              clientName={openUpdateGroupsDialog.clientName}
              username={openUpdateGroupsDialog.username}
              staffGroupsCount={openUpdateGroupsDialog.staffGroupsCount}
              clntAllGrpAndIfIsStfGrp2Lst={
                openUpdateGroupsDialog.clntAllGrpAndIfIsStfGrp2
              }
              reloadPageFunc={reloadPageFunc}
              closeDialog={() => setOpenUpdateGroupsDialog(null)}
            />
          )}
          {alertDeleteMsg.msg && (
            <AlertDialog
              title={alertDeleteMsg.title}
              type={alertDeleteMsg.type}
              contentMsg={alertDeleteMsg.msg}
              closeDialog={() => setAlertDeleteMsg([])}
              deleteAction={() => {
                setAlertDeleteMsg([]);
                deleteGroupUserFunc(alertDeleteMsg.groupId);
              }}
            />
          )}
        </div>
      </div>
    );
  else
    return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Permission"
                contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );
  else return;
}

export default StaffGroups;
